import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { Text } from 'components/ui';
import CompareZoneBase from 'components/Catalog/ProductGrid/CompareModal/Zones/CompareZoneBase';

const SizesZone = ({ selectedProducts = [], getText = () => {} }) => {
    const renderContent = () => {
        return (
            <Text
                fontSize='sm'
                color='gray'
            >
                Sizes Zone
            </Text>
        );
    };

    return (
        <CompareZoneBase
            selectedProducts={selectedProducts}
            getText={getText}
            titleKey='sizes'
            renderContent={renderContent}
        />
    );
};

SizesZone.propTypes = {
    selectedProducts: PropTypes.arrayOf(PropTypes.object),
    getText: PropTypes.func
};

export default wrapFunctionalComponent(SizesZone, 'SizesZone');
